import '../../../src/stylus/components/_grid.styl';
import Grid from './grid';
export default Grid('layout');
//# sourceMappingURL=VLayout.js.map